import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import UserLayout from '../layouts/UserLayout';
import ZoomMeeting from '../components/zoom/ZoomMeeting';
import PageNotFound from '../pages/error/PageNotFound';
import { isFeedFeatureEnabled } from '../utils/featureFlags';

// pages/user/dashboard, pages/user/profile
import UserDashboard from '../pages/user/dashboard/Dashboard';
import UserProfile from '../pages/user/profile/Profile';

// pages/user/course — catalogue, watch, quiz result, PayU checkout
import UserCourses from '../pages/user/course/Courses';
import CourseDetails from '../pages/user/course/CourseDetails';
import CourseWatch from '../pages/user/course/CourseWatch/CourseWatch';
import OrderDetailsWithPayu from '../pages/user/course/OrderDetailsWithPayu';
import Result from '../pages/user/course/CourseWatch/Result';
import Resultvideo from '../pages/user/course/CourseWatch/Resultvideo';
// pages/user/settings — PayU return pages opened from the course checkout
import SuccessPayUPayment from '../pages/user/settings/SuccessPayUPayment';
import CancelPayUPayment from '../pages/user/settings/CancelPayUPayment';

// pages/user/classroom — classrooms, assignments, assessments
import AllClassroom from '../pages/user/classroom/AllClassroom';
import UserClassroom from '../pages/user/classroom/Classroom';
import AssignmentQuestions from '../pages/user/classroom/AssignmentQuestions';
import AssessmentQuestions from '../pages/user/classroom/AssessmentQuestions';
import AssessmentQuiz from '../pages/user/classroom/AssessmentQuiz';
import AssignmentQuizResult from '../pages/user/classroom/AssignmentQuizResult';
import AssignmentQuiz from '../pages/user/classroom/AssignmentQuiz';
import PdfViewerPage from '../pages/user/classroom/PdfViewerPage';

// pages/user/certificates, pages/user/notification
import UserCertificates from '../pages/user/certificates/Certificates';
import UserNotifications from '../pages/user/notification/Notifications';
import NotificationDetails from '../pages/user/notification/NotificationDetails';

// pages/user/settings, pages/user/help
import Settings from '../pages/user/settings/Settings';
import Help from '../pages/user/help/Help';
import Faq from '../pages/user/help/Faq';
import Ticket from '../pages/user/help/Ticket';

// pages/user/feed — shown only when REACT_APP_FEATURE_FEED=yes
import Feed from '../pages/user/feed/Feed';
import MyFeed from '../pages/user/feed/MyFeed';

function featurePage(enabled, page, fallbackPath) {
  return enabled ? page : <Navigate to={fallbackPath} replace />;
}

function UserRoutes() {
  const feedEnabled = isFeedFeatureEnabled();

  return (
    <>
      <Routes>
        {/* Standalone pages — no user layout */}
        <Route path="/user/assessmentQuiz/:encodedAssessmentId" element={<AssessmentQuiz />} />
        <Route path="/user/pdf-viewer" element={<PdfViewerPage />} />
        <Route path="/zoom-meeting" element={<ZoomMeeting />} />

        <Route path="/user" element={<UserLayout />}>
          {/* pages/user/dashboard, pages/user/profile */}
          <Route path="dashboard" element={<UserDashboard />} />
          <Route path="profile" element={<UserProfile />} />

          {/* pages/user/classroom */}
          <Route path="AllClassroom" element={<AllClassroom />} />
          <Route path="AllClassroom/classroomDetails/:encodedClassroomID" element={<UserClassroom />} />
          <Route path="assignmentsQuestions/:encodedAssignmentId" element={<AssignmentQuestions />} />
          <Route path="assignment-quiz/:encodedAssignmentId/:encodedQuestionId" element={<AssignmentQuiz />} />
          <Route path="assessmentQuestions" element={<AssessmentQuestions />} />
          <Route path="assignmentQuizResult" element={<AssignmentQuizResult />} />

          {/* pages/user/course and PayU return pages */}
          <Route path="courses" element={<UserCourses />} />
          <Route path="courses/courseDetails/:encodedId" element={<CourseDetails />} />
          <Route path="courses/WatchCourse/:encodedId" element={<CourseWatch />} />
          <Route path="courses/orderDetails" element={<OrderDetailsWithPayu />} />
          <Route path="courses/orderDetailsWithPayu" element={<OrderDetailsWithPayu />} />
          <Route path="courses/successPayUPayment" element={<SuccessPayUPayment />} />
          <Route path="courses/cancelPayUPayment" element={<CancelPayUPayment />} />
          <Route path="courses/result" element={<Result />} />
          <Route path="resultvideo" element={<Resultvideo />} />

          {/* pages/user/certificates */}
          <Route path="certificates" element={<UserCertificates />} />

          {/* pages/user/notification */}
          <Route path="notifications" element={<UserNotifications />} />
          <Route path="notifications/notificationDetails" element={<NotificationDetails />} />

          {/* pages/user/settings */}
          <Route path="settings" element={<Settings />} />

          {/* pages/user/help */}
          <Route path="help" element={<Help />} />
          <Route path="help/faq" element={<Faq />} />
          <Route path="help/ticket" element={<Ticket />} />

          {/* pages/user/feed */}
          <Route path="feed" element={featurePage(feedEnabled, <Feed />, '/user/dashboard')} />
          <Route path="my-feed" element={featurePage(feedEnabled, <MyFeed />, '/user/dashboard')} />

          {/* pages/error */}
          <Route path="*" element={<PageNotFound />} />
        </Route>

        <Route path="*" element={<PageNotFound />} />
      </Routes>
      <ToastContainer />
    </>
  );
}

export default UserRoutes;
